import type { CrudAdapter } from '@botto/core';
import { useCrudDataSource } from '@botto/core';
import { smsClient } from '../client';
import type { Direction, DirectionCreate, DirectionUpdate } from '../types';

export const directionsAdapter: CrudAdapter<Direction, DirectionCreate, DirectionUpdate> = {
  async list({ offset, limit, sortName, sortDirection }) {
    const { data, error } = await smsClient.GET('/directions/', {
      params: {
        query: {
          offset,
          limit,
          'sort.name': sortName ?? 'id',
          'sort.direction': (sortDirection ?? 'asc') as 'asc' | 'desc',
        },
      },
    });
    if (error) throw error;
    return { items: data?.items ?? [], total: data?.total ?? 0 };
  },
  async create(payload) {
    const { data, error } = await smsClient.POST('/directions/', { body: payload });
    if (error) throw error;
    return { id: data?.id ?? 0 };
  },
  async update(payload) {
    const { data, error } = await smsClient.PUT('/directions/', { body: payload });
    if (error) throw error;
    return (data ?? payload) as Direction;
  },
  async byKey(id) {
    const { data, error } = await smsClient.GET('/directions/{item_id}', {
      params: { path: { item_id: Number(id) } },
    });
    if (error) throw error;
    return data as Direction;
  },
  async remove(id) {
    const { error } = await smsClient.DELETE('/directions/{item_id}', {
      params: { path: { item_id: Number(id) } },
    });
    if (error) throw error;
  },
};

export const directionsStore = useCrudDataSource(directionsAdapter);
